import { supabase } from '@/integrations/supabase/client';

export type HomeEvent =
  | 'search_started'
  | 'example_prompt_clicked'
  | 'goal_selected'
  | 'featured_tool_opened'
  | 'compare_cta_clicked'
  | 'register_cta_clicked'
  | 'registration_completed';

const SESSION_KEY = 'home_v2_sid';
const REG_INTENT_KEY = 'home_v2_reg_intent';

function sessionId(): string {
  try {
    let id = sessionStorage.getItem(SESSION_KEY);
    if (!id) {
      id = crypto.randomUUID();
      sessionStorage.setItem(SESSION_KEY, id);
    }
    return id;
  } catch {
    return crypto.randomUUID();
  }
}

/** Fire-and-forget, pseudonymous homepage conversion event. Never send raw search text. */
export function trackHome(event: HomeEvent, label?: string) {
  try {
    if (event === 'register_cta_clicked') sessionStorage.setItem(REG_INTENT_KEY, '1');
    void supabase
      .from('homepage_events')
      .insert({ event_name: event, session_id: sessionId(), label: label?.slice(0, 60) ?? null })
      .then(() => undefined, () => undefined);
  } catch {
    /* analytics must never break the page */
  }
}

/** Called after a successful signup; logs once only if the user came from a homepage registration CTA. */
export function trackRegistrationIfFromHome() {
  try {
    if (sessionStorage.getItem(REG_INTENT_KEY) !== '1') return;
    sessionStorage.removeItem(REG_INTENT_KEY);
    trackHome('registration_completed');
  } catch {
    /* ignore */
  }
}
